import React from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import PendingNotesBriefing from './PendingNotesBriefing';
import { todayLocalDateString } from '@/utils/dateUtils';

const GuidedModeSidebar = ({
  guidedWorkflowData,
  dashboardData,
  currentEncounter,
  onNoteClick,
  onSaveProgress,
  isSavingProgress,
}) => {
  if (!guidedWorkflowData) return null;

  const sidebarData = guidedWorkflowData.notes
    ? {
        ...guidedWorkflowData,
        notes: guidedWorkflowData.notes.map((patient) => ({
          ...patient,
          sessions: patient.sessions.map((session) => ({
            ...session,
            dashboardContext: dashboardData?.enriched_timeline?.find(
              item => item.encounter_id === session.encounter_id,
            )?.context || session.dashboardContext,
          })),
        })),
      }
    : {
        ...guidedWorkflowData,
        notes: Object.values(
          (guidedWorkflowData.appointments || []).filter((appointment, index, appointments) =>
            appointments.findIndex(candidate => candidate.encounter_id === appointment.encounter_id) === index,
          ).reduce((groups, appointment) => {
            const patientId = appointment.patient_id || appointment.encounter_id;
            const patient = groups[patientId] || {
              patient_id: patientId,
              patient_name: appointment.patient_name || 'Client',
              sessions: [],
            };
            patient.sessions.push({
              encounter_id: appointment.encounter_id,
              date: appointment.date || todayLocalDateString(),
              time: appointment.time,
              session_type: appointment.session_type || 'Session',
                 status: appointment.status === 'Ready to sign' ? 'drafted' : appointment.status || 'pending',
                 note_id: appointment.note_id,
              default_template_id: appointment.default_template_id,
              default_template_name: appointment.default_template_name,
              dashboardContext: dashboardData?.enriched_timeline?.find(
                item => item.encounter_id === appointment.encounter_id,
              )?.context || undefined,
            });
            groups[patientId] = patient;
            return groups;
          }, {} as Record<string, { patient_id: string; patient_name: string; sessions: Array<Record<string, string | undefined>> }>),
        ),
      };

  return (
    <>
      {sidebarData.notes ? (
        <PendingNotesBriefing
          guidedWorkflowData={sidebarData}
          dashboardData={dashboardData}
          currentEncounter={currentEncounter}
          onNoteClick={onNoteClick}
        />
      ) : null}
      {onSaveProgress && (
        <Box sx={{ px: 2, py: 1.5, borderTop: '1px solid var(--tile-border, #e5e7eb)' }}>
          <Button
            fullWidth
            size="small"
            variant="outlined"
            startIcon={isSavingProgress ? <CircularProgress size={16} /> : <SaveIcon />}
            disabled={isSavingProgress}
            onClick={onSaveProgress}
            sx={{
              textTransform: 'none',
              borderColor: 'var(--c1, #57bde4)',
              color: 'var(--c1-dark, #2c8db7)',
              '&:hover': { borderColor: 'var(--c1-dark, #2c8db7)', bgcolor: 'rgba(87,189,228,0.06)' },
            }}
          >
            {isSavingProgress ? 'Saving...' : 'Save Progress'}
          </Button>
        </Box>
      )}
    </>
  );
};

export default GuidedModeSidebar;
